import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import dynamic from 'next/dynamic'
import { Col, Row } from 'react-bootstrap'
import { useLazyQuery } from '@apollo/client'

import styles from '../stats/style.module.scss'
import { GET_TEAM_PLAYER } from '@graphql/series/squads.query'
import { useRouter } from 'next/router'
import useWindowSize from '@shared/hooks/windowSize'
import Slider from '@shared/components/slider'

const ArticleSkeleton = dynamic(() => import('@shared/components/skeleton/components/articleSkeleton'), { ssr: false })
const SquadsCard = dynamic(() => import('@shared/components/searchComponents/squadsCard'), { loading: () => <ArticleSkeleton type="t" /> })
const SquadsTeamCard = dynamic(() => import('@shared/components/searchComponents/squadsTeamCard'))
const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })

function SeriesSquads({ team = [], players, id }) {
  const [player, setPlayer] = useState(players)
  const newTeam = team?.filter(data => data?._id !== '622d96830961155e958ac6cf')
  const teamNameRef = useRef(newTeam[0]?.sTitle)
  const router = useRouter()
  const { teamid } = router.query
  // const activeTeamRef = useRef(router.query?.teamid ? newTeam?.filter((data) => data?._id === router.query?.teamid)?.[0] : newTeam[0])
  const [getPlayers, { data, loading }] = useLazyQuery(GET_TEAM_PLAYER)
  const [width] = useWindowSize()
  const [activeTeam, setActiveTeam] = useState(
    router.query?.teamid ? newTeam?.filter(data => data?._id === router.query?.teamid)?.[0] : newTeam[0]
  )
  useEffect(() => {
    if (data?.listSeriesSquad) {
      setPlayer(data?.listSeriesSquad)
    }
  }, [data])

  useEffect(() => {
    if (teamid) {
      getPlayers({ variables: { input: { iSeriesId: id, iTeamId: teamid } } })
    }
  }, [])

  useEffect(() => {
    if (router.query?.teamid) {
      setActiveTeam(newTeam?.filter(data => data?._id === router.query?.teamid)?.[0])
    }
  }, [router.query?.teamid])

  const handleTeam = item => {
    router.push({ query: { ...router.query, teamid: item?._id } }, undefined, {
      shallow: true
    })
    teamNameRef.current = item?.sTitle
    getPlayers({ variables: { input: { iSeriesId: id, iTeamId: item?._id } } })
  }

  function onClickTeamWrapper(item) {
    handleTeam(item)
  }

  return (
    <>
      {newTeam?.length !== 0 || player?.length !== 0 ? (
        <>
          <div className={`common-box ${styles.squadBox}`}>
            <Row>
              <Col className={`${styles.teamsPanel}`} md={3}>
                {width > 767 ? (
                  <>
                    <Col key="Team_heading" md={6}>
                      <SquadsTeamCard title="Team" />
                    </Col>
                    {newTeam?.length !== 0 &&
                      newTeam?.map(t => {
                        return (
                          <Col key={t?._id} md={6} onClick={() => onClickTeamWrapper(t)}>
                            <SquadsTeamCard data={t} activeTeam={activeTeam?._id} width={width} />
                          </Col>
                        )
                      })}
                  </>
                ) : (
                  <Slider nav gap={0} destroyBelow={1199}>
                    {newTeam?.length !== 0 &&
                      newTeam?.map(t => {
                        return (
                          <div key={t?._id} onClick={() => onClickTeamWrapper(t)}>
                            <SquadsTeamCard data={t} activeTeam={activeTeam?._id} />
                          </div>
                        )
                      })}
                  </Slider>
                )}
              </Col>
              <Col className={`${styles.squadWidth}`} md={9}>
                <Row className="mb-2 mb-sm-1">
                  {width > 767 && (
                    <h4 className={`text-uppercase mb-4 mt-2 ${styles.squadhead}`}>
                      <div className="text-capitalize">
                        Squad
                      </div>
                    </h4>
                  )}
                  {loading ? (
                    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(e => (
                      <Col key={e} md={6}>
                        <ArticleSkeleton type="t" />
                      </Col>
                    ))
                  ) : player?.length > 0 ? (
                    <>
                      {!loading &&
                        player?.map(p => {
                          return (
                            <Col key={p?.oPlayer?._id} md={6} className={styles.playerWidth}>
                              <SquadsCard data={p?.oPlayer} />
                            </Col>
                          )
                        })}
                    </>
                  ) : (
                    <NoData title="The squad hasn’t hit the field yet. Check back later for the lineup magic!" />
                  )}
                </Row>
              </Col>
            </Row>
          </div>
        </>
      ) : (
        <NoData title="To be announced..." />
      )}
    </>
  )
}
SeriesSquads.propTypes = {
  team: PropTypes.array,
  players: PropTypes.array,
  id: PropTypes.string
}
export default SeriesSquads
